<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft-danger">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-danger p-4">
                           <h5 class="text-danger">¡Bienvenido de nuevo!</h5>
                           <p>Inicie sesión para continuar.</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                     <router-link tag="a" to="/">
                        <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-light">
                           <img src="@/assets/images/logo.png" alt height="50" />
                           </span>
                        </div>
                     </router-link>
                  </div>

                  <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

                  <b-form class="p-2" @submit.prevent="tryToLogIn">
                     <b-form-group id="input-group-1" label="Correo electrónico" label-for="input-1">
                        <b-form-input id="input-1" v-model="email" type="text" placeholder="Introduzca su correo electrónico"></b-form-input>
                     </b-form-group>

                     <b-form-group id="input-group-2" label="Password" label-for="input-2">
                        <b-form-input id="input-2" v-model="password" type="password" placeholder="Introduzca su contraseña"></b-form-input>
                     </b-form-group>
                     <!-- <div class="custom-control custom-checkbox">
                        <input id="customControlInline" type="checkbox" class="custom-control-input" />
                        <label class="custom-control-label" for="customControlInline">Remember me</label>
                     </div> -->
                     <div class="mt-3">
                        <b-button type="submit" variant="danger" class="btn-block">Iniciar Sesión</b-button>
                     </div>
                     <!-- <div class="mt-4 text-center">
                        <router-link tag="a" to="/forgot-password" class="text-muted">
                           <i class="mdi mdi-lock mr-1"></i> ¿Olvidó su contraseña?
                        </router-link>
                     </div> -->
                  </b-form>
               </div>
            </div>

            <!-- <div class="mt-5 text-center">
               <p>
                  ¿ No tiene cuenta ?
                  <router-link tag="a" to="/registro" class="font-weight-medium text-danger">Regístrese ahora</router-link>
               </p>
               <p>© {{new Date().getFullYear()}} Portal ASEIN. Versión 1.0</p>
            </div> -->
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Account"
   import { authMethods } from "@/services/helpers"
   export default {
      title: "Login",
      data () {
         return {
            email: '',
            password: '',
            isAuthError: false,
            authError: null,
         }
      },
      components: {
         ...authMethods, Layout
      },
      methods: {
         tryToLogIn() {
            this.tryingToLogIn = true
            this.authError = null
            let email = this.email 
            let password = this.password
            let action = 'login'

            this.$store.dispatch('login', "json="+JSON.stringify({ email, password, action }))
            .then((resp) => {
               if (resp.data.res == 'success') {
                  this.isAuthError = false
                  this.authError = null
                  this.$router.push('/panel')
               } else {
                  this.authError = "Credenciales incorrectas"
                  this.isAuthError = true
               }
               this.tryingToLogIn = false
            })
            .catch(err => console.log(err))
         }
      }
      
   }
</script>